module.exports = __webpack_public_path__ + "static/img/cop_sch_logo17.76d8fc75.png";